module.exports = __webpack_public_path__ + "static/media/400070_01.9a4caf99.png";